import React from 'react';
import classNames from 'classnames';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import DataRoomNodeTagAndVersion from 'components/DataRoomNodeTagAndVersion';
import MymeTypeIcon from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/MymeTypeIcon';
import { displayDataRoomNodeSize, getNodeMimeType } from 'utils';
import usePastTime from 'hooks/usePastTime';
import DownloadIcon from 'icons/Download.icon';
import EyeIcon from 'icons/Eye.icon';
import { useTranslation } from 'react-i18next';

import './ShareableLinkFile.styles.scss';
import './ShareableLinkFile.styles.responsive.scss';

type ShareableLinkFileProps = {
  className?: string;
  dataRoomNode: DataRoomNode;
  numberOfDownloads: number;
  numberOfViews: number;
  lastAccessDate: Date;
  openFile: () => void;
  onClick: () => void;
};

const ShareableLinkFile: React.FC<ShareableLinkFileProps> = (props) => {
  const {
    className,
    dataRoomNode,
    numberOfDownloads,
    numberOfViews,
    lastAccessDate,
    onClick,
    openFile,
  } = props;

  const classes = classNames('shareable-link-file', className);

  const pastTime = usePastTime();

  const { document, name, tag, version } = dataRoomNode;

  const { t } = useTranslation();

  return (
    <div className={classes} onClick={onClick}>
      <div className="file-name">
        <MymeTypeIcon mimeType={getNodeMimeType(dataRoomNode)} />

        <span
          className="name"
          onClick={(e) => {
            e.stopPropagation();
            openFile();
          }}
        >
          {name}
        </span>

        <DataRoomNodeTagAndVersion tag={tag} version={version} />
      </div>

      <div className="file-insights">
        <span>
          <EyeIcon />
          {numberOfViews}
        </span>
        <span>
          <DownloadIcon />
          {numberOfDownloads}
        </span>
        <span>{displayDataRoomNodeSize(document?.size)}</span>
        <span>
          {lastAccessDate ? pastTime(lastAccessDate) : t('nobodyAccessed')}
        </span>
      </div>
    </div>
  );
};

export default ShareableLinkFile;
